// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"TrialNotification__materialize-textarea___3q0C0","modal-2463794813":"TrialNotification__modal-2463794813___3I7m_","container":"TrialNotification__container___1lZ8V","notification":"TrialNotification__notification___3SAIb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TrialNotification/TrialNotification.scss
// module id = 1543
// module chunks = 0